import {
  RequestEmailChangeRequest,
  RequestEmailChangeResponse,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type RequestEmailChangeOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  newEmail: string;
};

export const requestEmailChange = async <TFunctions>(
  options: RequestEmailChangeOptions<TFunctions>,
): Promise<RequestEmailChangeResponse> => {
  const { functions, httpsCallable, newEmail } = options;
  const callable = httpsCallable<
    RequestEmailChangeRequest,
    RequestEmailChangeResponse
  >(functions, 'users-requestEmailChange');

  return (await callable({ newEmail })).data;
};
